import {ISelectProps, Select} from 'native-base';
import React from 'react';

import {Properties} from 'store/properties/properties.interface';

interface PropertiesDropdownProps extends ISelectProps {
  properties: Properties;
  placeholder: string;
  isFullWidth?: boolean;
}

const PropertiesDropdown = (props: PropertiesDropdownProps) => {
  const {properties = [], isFullWidth, ...rest} = props;
  const {placeholder} = rest;

  return (
    <Select
      maxWidth={isFullWidth ? '100%' : '50%'}
      accessibilityLabel={placeholder}
      isDisabled={properties.length <= 1}
      {...rest}>
      {properties?.map(property => (
        <Select.Item
          label={property.name}
          value={property.id}
          key={`properties-dropdown-${property.id}`}
        />
      ))}
    </Select>
  );
};

export default PropertiesDropdown;
